import { z } from 'zod';
import { FEEDBACK_BODY_MAX_LENGTH } from '../../config.ts';

export const feedbackBodySchema = z
  .string()
  .trim()
  .min(1, 'feedback cannot be empty')
  .max(
    FEEDBACK_BODY_MAX_LENGTH,
    `feedback must be ${FEEDBACK_BODY_MAX_LENGTH} characters or fewer`,
  );
